import m from 'mithril'
import classNames from 'classnames'
import uuid from 'uuid'
import Uploader from './core'
import stream from 'mithril/stream'
import EditComponent from './edit'
import {
    Dialog
} from 'components'

const isOverlap = (dragObjectRect, dragOverObjectRect, shiftX, shiftY) => {
    let dragLeft = dragObjectRect.left + shiftX,
        dragTop = dragObjectRect.top + shiftY,
        dragRight = dragObjectRect.right + shiftX,
        dragBottom = dragObjectRect.bottom + shiftY

    const left = Math.max(dragLeft, dragOverObjectRect.left)
    const right = Math.min(dragRight, dragOverObjectRect.right)
    const top = Math.max(dragTop, dragOverObjectRect.top)
    const bottom = Math.min(dragBottom, dragOverObjectRect.bottom)
    if (left < right && top < bottom) {
        const width = right - left
        const height = bottom - top
        const intersec = width * height
        if (intersec > (dragOverObjectRect.width * dragOverObjectRect.height) / 2) {
            return true
        }
    }
    return false
}

let shift, dragObjectKey, dragObjectRect

class Thumb {
    constructor(vnode) {
        this.dragging = false
        this.indexCh = vnode.attrs.indexCh
    }
    findeItem(items, id) {
        return items.findIndex((item) => {
            return item.filename == id
        })
    }
    getPhoto(photo) {
        if (typeof photo === 'function') {
            return photo()
        }
        return photo
    }
    view(vnode) {
        if (!vnode.attrs.photo) {
            return
        }
        const idx = this.findeItem(vnode.attrs.items(), vnode.attrs.key)

        return [
            m(".col-md-3.col-12.px-1.py-2", [
                m(".card", [
                    m(".card-header.d-flex", [
                        
                    ]),
                    m(".card-body.p-1.d-flex.justify-content-center", [
                        m('.g-thumbnail.border.rounded', {
                            draggable: (vnode.attrs.readonly) ? false : true,
                            style: {
                                backgroundImage: (this.getPhoto(vnode.attrs.photo)) ? `url(${this.getPhoto(vnode.attrs.photo)})` : false,
                                cursor: (!vnode.attrs.readonly) ? 'move' : 'default',
                                width: "240px",
                                height: "240px"
                            },
                            class: classNames({
                                'dragging': (!vnode.attrs.readonly) ? this.dragging : false
                            }),
                            onmousedown: (e) => {
                                dragObjectRect = e.currentTarget.getBoundingClientRect()
                            },
                            onmouseover: (e) => {
                                if (vnode.attrs.readonly) {
                                    return false
                                }
                                const trash = vnode.dom.querySelector('.g-thumbnail-trash')
                                trash.style.opacity = 1;
                                // const pencil = vnode.dom.querySelector('.g-thumbnail-pencil')
                                // pencil.style.opacity = 1;
                                const change = vnode.dom.querySelector('.g-thumbnail-change')
                                change.style.opacity = 1;
                            },
                            onmouseout: (e) => {
                                if (vnode.attrs.readonly) {
                                    return false
                                }
                                const trash = vnode.dom.querySelector('.g-thumbnail-trash')
                                trash.style.opacity = 0;
                                // const pencil = vnode.dom.querySelector('.g-thumbnail-pencil')
                                // pencil.style.opacity = 0;
                                const change = vnode.dom.querySelector('.g-thumbnail-change')
                                change.style.opacity = 0;
                            },
                            ondragstart: (e) => {
                                if (vnode.attrs.readonly) {
                                    return false
                                }
                                const trash = vnode.dom.querySelector('.g-thumbnail-trash')
                                trash.style.opacity = 0;
                                // const pencil = vnode.dom.querySelector('.g-thumbnail-pencil')
                                // pencil.style.opacity = 0;
                                const change = vnode.dom.querySelector('.g-thumbnail-change')
                                change.style.opacity = 0;
                                e.dataTransfer.effectAllowed = 'move'
                                shift = {
                                    x: e.pageX,
                                    y: e.pageY
                                }
                                dragObjectKey = vnode.attrs.key
                                dragObjectRect = e.currentTarget.getBoundingClientRect()
                                this.cloneNode = e.currentTarget.cloneNode(true)
                                this.cloneNode.style.width = dragObjectRect.width + 'px'
                                this.cloneNode.style.height = dragObjectRect.height + 'px'
                                this.cloneNode.style.position = 'fixed'
                                this.cloneNode.style.bottom = '-10000px'
                                this.cloneNode.style.backgroundSize = 'cover'
                                this.cloneNode.style.backgroundPosition = 'center'

                                document.body.appendChild(this.cloneNode)
                                e.dataTransfer.setDragImage(this.cloneNode, e.clientX - dragObjectRect.left, e.clientY - dragObjectRect.top)
                                this.dragging = true
                            },
                            ondragover: (e) => {
                                e.preventDefault()

                                if (vnode.attrs.key === dragObjectKey) {
                                    return false
                                }

                                const mouseShift = {
                                    x: e.pageX - shift.x,
                                    y: e.pageY - shift.y
                                }
                                const overRect = e.currentTarget.getBoundingClientRect()
                                //是否overlap超過drag over object的一半面積
                                const overlap = isOverlap(dragObjectRect, overRect, mouseShift.x, mouseShift.y)

                                if (overlap) {
                                    const to = this.findeItem(vnode.attrs.items(), vnode.attrs.key)
                                    const from = this.findeItem(vnode.attrs.items(), dragObjectKey)
                                    vnode.attrs.items().splice(to, 0, vnode.attrs.items().splice(from, 1)[0])
                                }
                            },
                            ondragend: (e) => {
                                this.dragging = false
                                document.body.removeChild(this.cloneNode)

                            }
                        }, [
                            // (!vnode.attrs.readonly) ? [
                            // m('label.g-thumbnail-pencil', [
                            //     m('a', {
                            //         title: '編輯屬性',
                            //         href: '#',
                            //         onclick: (e) => {
                            //             e.preventDefault()
                            //             Dialog.show(EditComponent, {
                            //                 attrs: {
                            //                     model: vnode.attrs.items()[idx],
                            //                 },
                            //                 didHide: (returnValue) => {
                            //                     if (returnValue != undefined) {
                            //                         vnode.attrs.items()[idx] = returnValue
                            //                     }

                            //                 }
                            //             })
                            //         }
                            //     }, m('i.fa.fa-pencil.text-white'))
                            // ]),
                            m('label.g-thumbnail-change[for="change_banner"]', [
                                m('a.', {
                                    title: '更換圖片',
                                    href: '#',
                                    onclick: (e) => {
                                        e.preventDefault()
                                        this.indexCh(idx)
                                    }
                                }, m('i.fa.fa-redo.text-white'))
                            ]),
                            m('label.g-thumbnail-trash', [
                                m('a', {
                                    title: '刪除圖片',
                                    href: '#',
                                    onclick: (e) => {
                                        e.preventDefault()
                                        const idx = this.findeItem(vnode.attrs.items(), vnode.attrs.key)
                                        vnode.attrs.items().splice(idx, 1)
                                    }
                                }, m('i.fa.fa-trash.text-white'))
                            ]),
                        ]),
                    ]),
                ]),
            ])
        ]
    }
}

class BannersPhotosUploader {
    constructor(vnode) {
        this.items = vnode.attrs.items
        this.indexCh = stream()
    }
    view(vnode) {
        return m('.g-photos_wrapper.d-flex.flex-wrap.justify-content-center.justify-content-md-start.w-100', {
            style: {
                maxHeight: '100%',
                margin: '10px'
            }
        }, [
            m(".row.w-100", [
                this.items().map((item, index) => {
                    name = item.filename
                    item = vnode.attrs.storepath + item.filename
                    return m(Thumb, {
                        items: this.items,
                        key: name,
                        id: item.id,
                        photo: item,
                        progress: item.progress,
                        readonly: vnode.attrs.disabled,
                        code: item.code,
                        index: index,
                        indexCh: this.indexCh
                    })
                }),
                m(".col-md-3.col-12.px-1.py-2", [
                    m(".card", [
                        m("h5.card-header", [
                            "新增"
                        ]),
                        m(".card-body.p-1", [
                            m('label.g-uploader-indicator.w-100.d-flex.align-items-center[for="banner_files"]', {
                                style: {
                                    // width: "400px",
                                    // height: "181.6px"
                                }
                            }, [
                                m('i.fa.fa-upload', {
                                    style: {
                                        "fontSize": "2rem"
                                    }
                                })
                            ]),
                        ])
                    ])
                ]),
            ]),

            m('input.g-file_browser[type="file"][name="files[]"][accept="image/*"][id="banner_files"]', {
                multiple: true,
                onchange: (e) => {
                    if (e.target.files.length === 0) {
                        return false
                    }
                    for (let i = 0; i < e.target.files.length; i++) {
                        const id = uuid()
                        const uploader = new Uploader
                        if (!uploader.filterImageExtension(e.target.files)) {
                            alert('不支援上傳的檔案格式, 請選擇圖片檔!')
                            return false
                        }
                        uploader.uploadImage(e.target.files[i], {
                            url: vnode.attrs.url,
                            preview: true,
                            width: vnode.attrs.width,
                            height: vnode.attrs.height,
                            folder: vnode.attrs.folder,
                            type: "banner",
                        }).then((response) => {
                            this.items()[this.items().length] = {
                                "filename": response.filename,
                                "url": response.web_url,
                                "sort": this.items().length
                            }
                        })
                    }
                }
            }),
            m('input.g-file_browser[type="file"][name="files[]"][accept="image/*"][id="change_banner"]', {
                multiple: true,
                oninput: (e) => {
                    if (e.target.files.length === 0) {
                        return false
                    }
                    for (let i = 0; i < e.target.files.length; i++) {
                        const id = uuid()
                        const uploader = new Uploader
                        if (!uploader.filterImageExtension(e.target.files)) {
                            alert('不支援上傳的檔案格式, 請選擇圖片檔!')
                            return false
                        }
                        uploader.uploadImage(e.target.files[i], {
                            url: vnode.attrs.url,
                            preview: true,
                            width: vnode.attrs.width,
                            height: vnode.attrs.height,
                            folder: vnode.attrs.folder,
                            type: "banner",
                        }).then((response) => {
                            this.items()[this.indexCh()].filename = response.filename
                            this.items()[this.indexCh()].url = response.web_url
                        })
                    }
                }
            })
            // ] : '',
        ])
    }
}

export default BannersPhotosUploader